import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { style } from './menu-item.style.js'
import { LinkTargetTypes } from 'elements/link/link.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'


export const menuItemVariants = ['default', 'link'] as const
export type menuItemVariantTypes = typeof menuItemVariants

@customElement('cse-menu-item')
export class CSEMenuItem extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, style]

  @property({ type: Boolean })
  selected = false

  @property({ type: Boolean })
  disabled = false

  @property()
  url = ''

  @property()
  target: LinkTargetTypes[number] = '_self'

  @property({ type: String })
  variant: menuItemVariantTypes[number] = 'default'

  override render() {
    const classes = classMap({
      'cse-menu-item': true,
      'selected': this.selected,
      'disabled': this.disabled,
      'font-body': true,
      [`variant-${this.variant}`]: true,
    })

    if (this.disabled) {
      return html`
        <span class="${classes}">
          <slot name="prefix"></slot>
          <slot></slot>
          <slot name="suffix"></slot>
        </span>
      `
    }

    return html`
      <a
        href=${this.url}
        target=${this.target}
        class=${classes}
      >
        <slot name="prefix"></slot>
        <slot></slot>
        <slot name="suffix"></slot>
      </a>
    `
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cse-menu-item': CSEMenuItem
  }
}
